module.exports = __webpack_public_path__ + "img/desc.65096cfa.jpg";